import { render, staticRenderFns } from "./tyokertymalaskuri-tyoskentelyjakso-form.vue?vue&type=template&id=4f3954f8&scoped=true&"
import script from "./tyokertymalaskuri-tyoskentelyjakso-form.vue?vue&type=script&lang=ts&"
export * from "./tyokertymalaskuri-tyoskentelyjakso-form.vue?vue&type=script&lang=ts&"
import style0 from "./tyokertymalaskuri-tyoskentelyjakso-form.vue?vue&type=style&index=0&id=4f3954f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3954f8",
  null
  
)

export default component.exports